<template>
  <div class="drawer">
    <el-drawer
      class="p-t-45"
      :visible.sync="drawer"
      direction="ttb"
      :wrapperClosable="false"
      :show-close="false"
    >
      <Tree :list="navList" @close="onClose" />
    </el-drawer>
  </div>
</template>

<script>
import Tree from '@/components/Tree/index'
export default {
  components: {
    Tree,
  },
  data() {
    return {
      drawer: this.value,
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    navList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    value(val) {
      this.drawer = val
    },
  },
  methods: {
    onClose(data) {
      this.$emit('input', data)
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer {
  /deep/ {
    .el-drawer {
      height: 100% !important;
    }
    .el-drawer__header {
      padding: 0;
      margin-bottom: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MobileNav/index.vue